// 默认theme列表
const DEFAULT_THEME_CONF = [
  '#0067ed',  // blue
  '#4A70FF',  // default
  '#ff9232',  // orange
  '#ee685d',  // red
  '#25cd98',  // green
];

// 默认颜色
const DEFAULT_COLOR = DEFAULT_THEME_CONF[1];

const THEME_KEY_PREFIX = 'qdim_saas_theme_config-';

// 设置背景颜色
function mergeThemeConf({ bgColor }) {
  const styleString = `--bg-color: ${bgColor ? bgColor : DEFAULT_COLOR};`;
  return styleString;
}

/**
 * 解析配置
 */
function parseStyleConfig(themeConf) {
  const { theme, inputStyleConfig } = themeConf;
  const { themeColor, backgroundImage } = (inputStyleConfig || {});

  let bgColor;
  let h5BgImage;
  let pcBgImage;

  if (themeColor) {
    bgColor = themeColor;
  } else if (theme !== '') {
    bgColor = DEFAULT_THEME_CONF[theme];
  }
  if (backgroundImage) {
    h5BgImage = backgroundImage.mobile || '';
    pcBgImage = backgroundImage.pc || '';
  }

  return {
    bgColor,
    h5BgImage,
    pcBgImage,
  };
}

/**
 * 获取样式
 * @param {*} wpaDetail
 * @param {*} callback
 */
export function getThemeConf(wpaDetail, newThemeConf: any = null): Object {
  const { kfuin } = wpaDetail;
  const THEME_KEY = THEME_KEY_PREFIX + kfuin;
  let setting: any = null;

  // 没有外部传入，此时使用本地缓存的配置
  if (!newThemeConf) {
    let cacheTheme = {};
    // 1. 先读取本地缓存
    try {
      cacheTheme = JSON.parse(localStorage.getItem(THEME_KEY) || '{}');
    } catch (ex) { }
    setting = parseStyleConfig(cacheTheme);
    return { customStyle: mergeThemeConf(setting), setting };
  }

  // 有外部数据传入，需要和本地数据进行merge并缓存
  const { theme, inputStyleConfig = {} } = newThemeConf;
  const themeConf = { theme, inputStyleConfig };
  // 缓存配置
  try {
    localStorage.setItem(THEME_KEY, JSON.stringify(themeConf));
  } catch (ex) { }
  setting = parseStyleConfig(themeConf);
  return { customStyle: mergeThemeConf(setting), setting };
}
